// extracted by mini-css-extract-plugin
export var item = "Faq-module--item--78a7d";
export var title = "Faq-module--title--ef761";
export var wrapper = "Faq-module--wrapper--00fe9";